import type { FC } from 'react';

import { Notification } from '@coop/components';

import type { ErrorGroup } from '../../../store/structureDefinitions/errorsState';

import { useGroupError } from '../../../hooks/useGroupError';

interface ErrorGroupNotificationProps {
    errorGroup: ErrorGroup;
}

const ErrorGroupNotification: FC<React.PropsWithChildren<ErrorGroupNotificationProps>> = (
    props,
) => {
    const { firstError: globalFlyInError, clearGroupErrors: clearGlobalFlyInError } = useGroupError(
        props.errorGroup,
    );

    return (
        <Notification
            type="alert"
            message={globalFlyInError?.friendlyMessage}
            show={!!globalFlyInError}
            close={clearGlobalFlyInError}
        />
    );
};

export default ErrorGroupNotification;
